<script setup>
import { computed, defineAsyncComponent } from "vue";

// 懒加载 Airwallex drop-in，避免把 @airwallex/components-sdk 打进主包
const Airwallex = defineAsyncComponent(() => import("./Airwallex.vue"));

const props = defineProps({
  /** 弹窗显隐（:visible.sync 使用） */
  visible: {
    type: Boolean,
    default: false,
  },
  /** 支付 intent 数据：create_payment 等接口返回 */
  data: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  /** 环境：'demo'（沙箱）或 'prod'（生产） */
  env: {
    type: String,
    default: () => (process.env.NODE_ENV === "production" ? "prod" : "demo"),
  },
});

const emit = defineEmits(["update:visible", "success", "error", "close"]);

const dialogVisible = computed({
  get: () => props.visible,
  set: (val) => emit("update:visible", val),
});

/** 弹窗关闭后：通知父组件（由父清空 intent 数据） */
function onDialogClose() {
  emit("close");
}
</script>

<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="500px"
    custom-class="dialog-airwallex"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    top="2vh"
    @close="onDialogClose">
    <Airwallex
      v-if="dialogVisible"
      class="dialog-airwallex__dropin"
      :intentId="data.intent_id"
      :clientSecret="data.client_secret"
      :currency="data.currency"
      :env="env"
      @success="(data) => emit('success', data)"
      @error="(error) => emit('error', error)" />
  </el-dialog>
</template>

<style lang="scss" scoped>
.dialog-airwallex__dropin {
  padding: 24px;
}
</style>

<style lang="scss">
.dialog-airwallex {
  border-radius: 12px;
  border: 1px solid #EDEDED;
  overflow: hidden;

  .el-dialog__body {
    padding: 0;
  }
}
</style>
